import { Service } from "./Service";
import { proxyUrl } from "../config";

export enum SignatureStatus
{
    Pending,
    Signed,
    Sent,
    Error
}
export interface ISignature
{
    id?: number,
    createdAt?: string | Date,
    updatedAt?: string | Date,
    expiresAt?: string | Date,
    signAt?: string | Date,
    signatureCode?: string,
    phone?: string,
    status: SignatureStatus,
    hasDisclaimerTime?: number
}
export interface IProcessHours
{
    id: number,
    risk: number,
    hour: string
}
export interface ErrorResponse
{
    status: boolean,
    message: string,
}
export interface ISignBody
{
    signatureCode: string
}
class SignatureService extends Service<ISignature>
{
    public getSignature(id: number, params?: any)
    {
        return Service.request<ISignature>(
        {
            method: "get",
            url: `/signatures/${id}`,
            params
        }, proxyUrl);
    }
    public putSignature(id: number, signBody: ISignBody)
    {
        return Service.request<ISignature>(
        {
            method: "put",
            url: `/signatures/${id}`,
            data: signBody
        }, proxyUrl);
    }
    public putSignatures(signBody: any)
    {
        return Service.request<ISignature[]>(
        {
            method: "put",
            url: `/signatures`,
            data: signBody
        }, proxyUrl);
    }
    public getRefreshSignature(params?: any)
    {
        return Service.request<ISignature[]>(
        {
            method: "get",
            url: `/refreshSignatures`,
            params
        }, proxyUrl);
    }
    public createSignatureNoPlan(userId: number, params?: any)
    {
        return Service.request<ISignature[]>(
        {
            method: "get",
            url: `/CreateSignatureNoPlan/${userId}`,
            params
        }, proxyUrl); 
    }
    public createSignatureByFinametrixContract(savingPlanId: number, params?: any)
    {
        return Service.request<ISignature[]>(
        {
            method: "get",
            url: `/CreateSignatureByFinametrixContract/${savingPlanId}`,
            params
        }, proxyUrl);
    }

    public createSignaturesBySavingsPlan(savingPlanId: number, promotionSlug: string, contractDocName: string)
    {
        return Service.request<ISignature[]>(
        {
            method: "get",
            url: `/createSignaturesBySavingsPlan/${savingPlanId}/${promotionSlug}/${contractDocName}`
        }, proxyUrl);
    }


    public requestSignatureNoPlanByDni(idDocument: string)
    {
        return Service.request<ISignature>(
        {
            method: "get",
            url: `/requestSignatureNoPlanByDni/${idDocument}`
        }, proxyUrl); 
    }
    public getProcessHours()
    {
        return Service.request<IProcessHours[]>(
        {
            method: "get",
            url: `/GetProcessHours`,
        }, proxyUrl)
    }
}

const service = new SignatureService();
export default service;